export default __webpack_public_path__ + "static/media/rule.07331cb2.svg";